import { render, staticRenderFns } from "./PageViewHealthProfiles.vue?vue&type=template&id=d74bd6d8&"
import script from "./PageViewHealthProfiles.vue?vue&type=script&lang=ts&"
export * from "./PageViewHealthProfiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports